import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";
import {
  QUEUE_ORDER,
  QUEUE_LABELS,
  QueueSummaryResponse,
  QueueSummarySection,
} from "@/services/workerApi";

const chartConfig: ChartConfig = {
  pending: { label: "En attente", color: "hsl(var(--chart-1))" },
  processing: { label: "En cours", color: "hsl(var(--chart-2))" },
};

// Profondeur instantanée des 7 files, en barres horizontales empilées
// (en attente + en cours). Repère d'un coup la saturation ET la famine.
export function QueueDepthBarChart({
  summary,
}: {
  summary: QueueSummaryResponse | null;
}) {
  if (!summary) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Chargement...</div>;
  }

  const data = QUEUE_ORDER.map((key) => {
    const section = summary[key] as QueueSummarySection | undefined;
    return {
      queue: QUEUE_LABELS[key],
      pending: section?.count ?? 0,
      processing: section?.processing_count ?? 0,
    };
  });

  const allZero = data.every((d) => d.pending === 0 && d.processing === 0);
  if (allZero) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Toutes les files sont vides</div>;
  }

  return (
    <ChartContainer config={chartConfig} className="h-[320px] w-full">
      <BarChart data={data} layout="vertical" margin={{ left: 12, right: 16 }}>
        <CartesianGrid horizontal={false} />
        <XAxis type="number" tickLine={false} axisLine={false} allowDecimals={false} />
        <YAxis
          type="category"
          dataKey="queue"
          tickLine={false}
          axisLine={false}
          width={150}
        />
        <ChartTooltip content={<ChartTooltipContent />} />
        <Bar dataKey="pending" stackId="a" fill="var(--color-pending)" radius={[4, 0, 0, 4]} />
        <Bar dataKey="processing" stackId="a" fill="var(--color-processing)" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ChartContainer>
  );
}
